import { render, staticRenderFns } from "./ChooseSchedulingObjective.vue?vue&type=template&id=b2d338d4&"
import script from "./ChooseSchedulingObjective.vue?vue&type=script&lang=js&"
export * from "./ChooseSchedulingObjective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports